import React from "react";

const getAnswerLabel = (item) => {
  if (!item.options || !item.opt_id || !item.answer_value) return "";

  const options = item.options.split(",").map(opt => opt.trim());
  const ids = item.opt_id.split(",").map(id => id.trim());

  if (item.answer_type === "checkbox-group") {
    const selectedIds = item.answer_value?.split(",") || [];
    return selectedIds
      .map(val => {
        const index = ids.indexOf(val.trim());
        return index !== -1 ? options[index] : null;
      })
      .filter(Boolean)
      .join(", ");
  }

  const index = ids.indexOf(item.answer_value);
  return index !== -1 ? options[index] : "";
};

const CustomField = ({ data }) => {
  return (
    <div>
      {data &&
        data.map((item) => {
          if (item) {
            let answerDisplay = "";

            switch (item.answer_type) {
              case "select":
              case "radio-group":
              case "checkbox":
                answerDisplay = getAnswerLabel(item);
                break;
              case "text":
              case "textarea":
                answerDisplay = item.answer_value || "";
                break;
              default:
                answerDisplay = "";
            }

            return (
              <div className="" key={item.field_id + item.field_title}>
                <div className="d-flex align-items-start justify-content-between mt-1">
                  <div className="w-50">
                    <span
                      style={{
                        lineHeight: 2,
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {item.field_title}
                    </span>
                  </div>
                  <div className="w-50">
                    <span style={{ lineHeight: "2", fontSize: "14px" }}>
                      {answerDisplay || ""}
                    </span>
                  </div>
                </div>
              </div>
            );
          } else {
            return null;
          }
        })}
    </div>
  );
};

export default CustomField;
